import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useToast } from '@/hooks/useToast'

interface UseErrorHandlerReturn {
  handleError: (error: unknown) => string
}

export const SERVER_DOWN_ERROR = 'SERVER_DOWN_ERROR'

export function useErrorHandler(): UseErrorHandlerReturn {
  const { t } = useTranslation()
  const { toast } = useToast()

  const handleError = (error: unknown): string => {
    let errorMessage = 'An error occurred. Please try again.'
    const networkErrorMessage = 'Network Error'

    if (error instanceof Error && error.message === networkErrorMessage) {
      toast({
        description: t('auth.serverError'),
        variant: 'destructive',
        position: 'top-center',
      })
      return ''
    }
    if (error instanceof AxiosError) {
      const status = error.response?.status
      const isNetworkError =
        error.code === 'ERR_NETWORK' ||
        error.code === 'ERR_INTERNET_DISCONNECTED' ||
        !error.response

      if ((status && status >= 500) || isNetworkError) {
        toast({
          description: t('auth.serverError'),
          variant: 'destructive',
          position: 'top-center',
        })
        return ''
      }

      errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        errorMessage
    } else if (error instanceof Error) {
      errorMessage = error.message
    }

    return errorMessage
  }

  return {
    handleError,
  }
}
